export function isMobileScreenSize(): boolean {
    return window.matchMedia("(max-width: 576px)").matches;
}
